var map = {
	"./callbone-small.png": 94813,
	"./callbone.png": 82031,
	"./comigo-small.png": 39313,
	"./comigo.png": 90531,
	"./icpas-small.png": 21007,
	"./icpas.png": 24197
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65962;